module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    staticClass: "fondo",
    attrs: {
      "name": "fade-smooth"
    }
  }, [_c('lista-reclamaciones', {
    key: "lista",
    ref: "lista",
    staticClass: "lista",
    on: {
      "selected": _vm.seleccionarReclamacion
    }
  }), (_vm.preimpreso) ? _c('div', {
    key: "respuesta",
    staticClass: "respuesta"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_c('span', [_vm._v("Seleccionado ")]), _c('strong', [_vm._v(_vm._s(_vm.preimpreso))])])]), _c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.preimpreso = ''
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(" Respuesta a la reclamación")]), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.respuesta),
      expression: "respuesta"
    }],
    staticClass: "textarea",
    attrs: {
      "rows": "5",
      "placeholder": "Ingrese la respuesta que quiere dar a la reclamación"
    },
    domProps: {
      "value": (_vm.respuesta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.respuesta = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "acciones"
  }, [_c('button', {
    staticClass: "button is-empresa button-responder",
    class: {
      'is-loading': _vm.isSending
    },
    on: {
      "click": _vm.enviarRespuesta
    }
  }, [_vm._v("Enviar respuesta")]), _c('button', {
    staticClass: "button bd-color-empresa fc-empresa",
    on: {
      "click": function($event) {
        _vm.preimpreso = ''
      }
    }
  }, [_vm._v("Cancelar")])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-268d1f6c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Responder.vue
// module id = 80
// module chunks = 0